import { useEffect, useMemo, useRef } from 'react';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, useMap, Popup } from 'react-leaflet';
import { Card, CardContent } from '@material-ui/core';

// local imports
import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconAnchor: [15, 30],
  popupAnchor: [0, -25]
});

L.Marker.prototype.options.icon = DefaultIcon;

const corner1 = L.latLng(-90, -200);
const corner2 = L.latLng(90, 200);
const bounds = L.latLngBounds(corner1, corner2);
const containerStyle = { height: '360px', borderRadius: 8 };

/* Draggable Marker Component */
function DraggableMarker({ setLocation, location }) {
  const markerRef = useRef(null);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        marker != null && setLocation(marker.getLatLng());
      }
    }),
    [setLocation]
  );

  return (
    <Marker draggable={false} eventHandlers={eventHandlers} position={location} ref={markerRef}>
      <Popup minWidth={90}>
        <div>
          <p>Lokasyon: {`${markerRef?.current?.getLatLng()}`}</p>
        </div>
      </Popup>
    </Marker>
  );
}

// fly to center on first render of the map
function ChangeView({ center }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center);
    return () => {};
  }, [center, map]);

  return null;
}

const LeafletMapForm = ({ setLocation, location }) => {
  return (
    <>
      <Card className="shadow-sm rounded">
        <CardContent className="m-0 p-0">
          <MapContainer
            center={location}
            maxZoom={18}
            minZoom={3}
            zoom={13}
            maxBoundsViscosity={1.0}
            maxBounds={bounds}
            style={containerStyle}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <ChangeView center={location} />
            <DraggableMarker setLocation={setLocation} location={location} />
          </MapContainer>
        </CardContent>
      </Card>
    </>
  );
};

export default LeafletMapForm;
